export { default } from './Banred';
